const defaultConfig = {
    isNew: true,
    name: `Widget ${Number( formychat_admin_vars.total.widgets ) + 1}`,
    is_active: true,
    config: formychat_admin_vars.data.widget_config || {},
}

if ( typeof window.formychat_country_code !== 'undefined' ) {
    defaultConfig.config.whatsapp.country_code = window.formychat_country_code
}

export default defaultConfig